import { useContext } from 'react';
import { useLocalObservable } from 'mobx-react';
import NotificationStore from '../Storage/NotificationStore';
import NotificationStoreContext from '../Contexts/NotificationStoreContext';

export const DEFAULT_ERROR_NOTIFICATION_DURATION = 5000;
export const DEFAULT_WARNING_NOTIFICATION_DURATION = 5000;

function useNotificationStore(): NotificationStore {
  const context = useContext(NotificationStoreContext);
  return useLocalObservable(() => context);
}

export default useNotificationStore;
